<template>
  <vue-scroll class="page-payment-provider">
    <div class="page-header">
      <h1><i :class="'mdi mdi-'+ $route.meta.icon"></i> {{ $route.name }}</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.name }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="card-base card-shadow--medium p-30">
      <el-row :gutter="50">
        
      </el-row>
    </div>
  </vue-scroll>
</template>

<script>
export default {
  name: "Configuration",
  data() {
    return {
      loading: false,
      loadingTable: false,
      edit: false,
      form: {
        //
      },
      tableData: [],
      search: ""
    };
  },
  methods: {
    //
  },
  created() {
    //
  }
};
</script>
<style lang="scss" scope>
.form {
  margin-top: 15px;
}
</style>

